// @core/api/endpoints/billing/attach_legal_entity_to_billing_account.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AttachLegalEntityToBillingAccountRequest,
  AttachLegalEntityToBillingAccountResponse,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Attach legal entity to billing account
 * Sets BillingAccount.legal_entity_ref. One billing account represents one legal entity; one legal entity may own multiple billing accounts (per currency, per product line). Contract rendering uses this link to resolve full bank requisites (via attached PaymentMethodDetail → BankAccountRequisites).
 */
export async function AttachLegalEntityToBillingAccount(
  billingAccountId: string,
  data: AttachLegalEntityToBillingAccountRequest,
  options?: RequestOptions
): Promise<AttachLegalEntityToBillingAccountResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/billing-accounts/:billingAccountId/legal-entity`;
  requestPath = requestPath.replace(':billingAccountId', encodeURIComponent(billingAccountId));
  const requestOptions = options;
  return client.post<AttachLegalEntityToBillingAccountResponse>(requestPath, data, requestOptions);
}
